module.exports = __webpack_public_path__ + "media/images/fbcalls/binance-ef411dfcaec0ee4035f351bf8b64b534.png";